import React from 'react'
import SEO from '../seo/SEO'; // Import SEO
import { FaqSEOData } from '../seo/FaqSEO'; // Import Data

export default function Faq() {
    return (
        <>
            {/* Inject FAQ Schema */}
            <SEO {...FaqSEOData} />

            <section className="py-5">
                <div className="container px-5 my-5">
                    <div className="text-center mb-5">
                        <h1 className="fw-bolder">Frequently Asked Questions</h1>
                        <p className="lead fw-normal text-muted mb-0">How can we help you?</p>
                    </div>

                    <div className="accordion mb-5" id="accordionExample">

                        {/* 1 */}
                        <div className="accordion-item">
                            <h3 className="accordion-header" id="headingOne">
                                <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne">
                                    പുസ്തകങ്ങൾ എങ്ങനെ വാങ്ങാം?
                                </button>
                            </h3>
                            <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                <div className="accordion-body">
                                    നമ്മുടെ പുസ്തകങ്ങൾ വാങ്ങാൻ മൂന്ന് മാർഗങ്ങൾ ലഭ്യമാണ്:
                                    <ul>
                                        <li>Amazon വഴി</li>
                                        <li>Flipkart വഴി</li>
                                        <li>WhatsApp ഉപയോഗിച്ച് നേരിട്ട് ഓർഡർ ചെയ്യാം (Direct Purchase)</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        {/* 2 */}
                        <div className="accordion-item">
                            <h3 className="accordion-header" id="headingTwo">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo">
                                    Direct Purchase എന്നത് എന്താണ്?
                                </button>
                            </h3>
                            <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                                <div className="accordion-body">
                                    വെബ്സൈറ്റിലെ WhatsApp ബട്ടൺ ക്ലിക്കുചെയ്ത്, നേരിട്ട് ഞങ്ങളോടൊപ്പം പുസ്തകത്തിന് ഓർഡർ ഇടാൻ നിങ്ങളെ സഹായിക്കുന്ന സൗകര്യമാണ് Direct Purchase.<br />
                                    നിങ്ങൾക്ക് പുസ്തകത്തിന്റെ പേര്, എണ്ണം, വിലാസം തുടങ്ങിയ വിവരങ്ങൾ WhatsApp വഴി പങ്കുവെച്ചു ഓർഡർ പൂർത്തിയാക്കാം.
                                </div>
                            </div>
                        </div>

                        {/* 3 */}
                        <div className="accordion-item">
                            <h3 className="accordion-header" id="headingThree">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree">
                                    Direct Purchase-ൽ പേയ്‌മെന്റ് എങ്ങനെ ചെയ്യാം?
                                </button>
                            </h3>
                            <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                                <div className="accordion-body">
                                    WhatsApp വഴി സംസാരിക്കുമ്പോൾ ഞങ്ങളുടെ ടീം നിങ്ങൾക്ക് ലഭ്യമായ പേയ്‌മെന്റ് മാർഗങ്ങളും (UPI/Bank Transfer മുതലായവ) അറിയിക്കും.
                                </div>
                            </div>
                        </div>

                        {/* 4 */}
                        <div className="accordion-item">
                            <h3 className="accordion-header" id="headingFour">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour">
                                    Amazon അല്ലെങ്കിൽ Flipkart വഴി വാങ്ങുന്നതിന് എന്താണ് പ്രത്യേകത?
                                </button>
                            </h3>
                            <div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#accordionExample">
                                <div className="accordion-body">
                                    <ul>
                                        <li>അതിവേഗ ഡെലിവറി</li>
                                        <li>ട്രാക്കിംഗ് സൗകര്യം</li>
                                        <li>Return/Refund നയങ്ങൾ ലഭ്യമാണ്</li>
                                    </ul>
                                    നിങ്ങൾക്ക് ഇഷ്ടമുള്ള പ്ലാറ്റ്ഫോം ഉപയോഗിച്ച് പുസ്തകം എളുപ്പത്തിൽ ഓർഡർ ചെയ്യാം.
                                </div>
                            </div>
                        </div>

                        {/* 5 */}
                        <div className="accordion-item">
                            <h3 className="accordion-header" id="headingFive">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive">
                                    പുസ്തകങ്ങളുടെ വില ഒരേപോലെയാണോ?
                                </button>
                            </h3>
                            <div id="collapseFive" className="accordion-collapse collapse" aria-labelledby="headingFive" data-bs-parent="#accordionExample">
                                <div className="accordion-body">
                                    പ്ലാറ്റ്ഫോം마다 ചെറിയ വിലവ്യത്യാസങ്ങൾ ഉണ്ടാകാം.
                                    Latest ഓഫറുകളും ഡീലുകളും Amazon/Flipkart-ൽ കാണാം.
                                    Direct Purchase-ൽ വിലയും ഷിപ്പിംഗ് വിവരങ്ങളും WhatsApp-ൽ അറിയിക്കും.
                                </div>
                            </div>
                        </div>

                        {/* 6 */}
                        <div className="accordion-item">
                            <h3 className="accordion-header" id="headingSix">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSix">
                                    Direct Purchase-ൽ ഷിപ്പിംഗ് ചാർജ് ഉണ്ടാകുമോ?
                                </button>
                            </h3>
                            <div id="collapseSix" className="accordion-collapse collapse" aria-labelledby="headingSix" data-bs-parent="#accordionExample">
                                <div className="accordion-body">
                                    അതെ, ഷിപ്പിംഗ് ചാർജ്ജ് സ്ഥലത്തെ ആശ്രയിച്ച് വ്യത്യാസപ്പെടാം. WhatsApp-ൽ സംസാരിക്കുമ്പോൾ ഞങ്ങളുടെ ടീം അത് നിങ്ങളെ അറിയിക്കും.
                                </div>
                            </div>
                        </div>

                        {/* 7 */}
                        <div className="accordion-item">
                            <h3 className="accordion-header" id="headingSeven">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeven">
                                    പുസ്തകം എത്ര ദിവസത്തിനുള്ളിൽ ലഭിക്കും?
                                </button>
                            </h3>
                            <div id="collapseSeven" className="accordion-collapse collapse" aria-labelledby="headingSeven" data-bs-parent="#accordionExample">
                                <div className="accordion-body">
                                    <ul>
                                        <li>Amazon/Flipkart: സാധാരണ 2–5 ദിവസങ്ങൾ</li>
                                        <li>Direct Purchase: ഷിപ്പിംഗ് ഏരിയയെ ആശ്രയിച്ച് 3–7 ദിവസങ്ങൾ</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        {/* 8 */}
                        <div className="accordion-item">
                            <h3 className="accordion-header" id="headingEight">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseEight">
                                    ഞാൻ പുസ്തകം തിരികെ നൽകണമെങ്കിൽ എന്താണ് പ്രക്രിയ?
                                </button>
                            </h3>
                            <div id="collapseEight" className="accordion-collapse collapse" aria-labelledby="headingEight" data-bs-parent="#accordionExample">
                                <div className="accordion-body">
                                    <ul>
                                        <li>Amazon/Flipkart വഴി വാങ്ങിയാൽ: അവരുടെ Return Policy അനുസരിച്ച് നേരിട്ട് Return request നൽകാം.</li>
                                        <li>Direct Purchase: കേടുപാടുള്ളത് അല്ലെങ്കിൽ തെറ്റായ പുസ്തകം ലഭിച്ചാൽ WhatsApp വഴി ഞങ്ങളെ ബന്ധപ്പെടുക.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        {/* 9 */}
                        <div className="accordion-item">
                            <h3 className="accordion-header" id="headingNine">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseNine">
                                    കസ്റ്റമർ സപ്പോർട്ടുമായി എങ്ങനെ ബന്ധപ്പെടാം?
                                </button>
                            </h3>
                            <div id="collapseNine" className="accordion-collapse collapse" aria-labelledby="headingNine" data-bs-parent="#accordionExample">
                                <div className="accordion-body">
                                    വെബ്സൈറ്റിലെ WhatsApp ബട്ടൺ ഉപയോഗിച്ച് ഞങ്ങളോട് നേരിട്ട് ആശയവിനിമയം നടത്താം.
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </section>
        </>
    )
}